var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarMetals(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM1.23887 8C1.23887 11.7341 4.26593 14.7611 8 14.7611C11.7341 14.7611 14.7611 11.7341 14.7611 8C14.7611 4.26593 11.7341 1.23887 8 1.23887C4.26593 1.23887 1.23887 4.26593 1.23887 8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9734 8C12.9734 10.7465 10.7469 12.973 8.00037 12.973C5.25384 12.973 3.02734 10.7465 3.02734 8C3.02734 5.25348 5.25384 3.02698 8.00037 3.02698C10.7469 3.02698 12.9734 5.25348 12.9734 8ZM4.2579 8C4.2579 10.0669 5.93346 11.7425 8.00037 11.7425C10.0673 11.7425 11.7428 10.0669 11.7428 8C11.7428 5.93309 10.0673 4.25753 8.00037 4.25753C5.93346 4.25753 4.2579 5.93309 4.2579 8Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarMetals);
export default __webpack_public_path__ + "static/media/sidebar-metals.baa2dd5ef818528b54707e8304fad6cc.svg";
export { ForwardRef as ReactComponent };